export interface CapabilityPolicy {
  defaultEnabled: boolean;
  override: { enabled: boolean; locationIds: readonly string[] | null } | null;
}

export function resolveCapabilityPolicy(
  policy: CapabilityPolicy,
  locationId?: string | null,
  options?: { allowTenantWide?: boolean },
): boolean {
  if (!policy.override) return policy.defaultEnabled;
  if (policy.override.locationIds === null) return policy.override.enabled;
  if (locationId === null && options?.allowTenantWide) return policy.defaultEnabled;
  if (!locationId) return false;
  return policy.override.locationIds.includes(locationId)
    ? policy.override.enabled
    : policy.defaultEnabled;
}
